module.exports = __webpack_public_path__ + "img/Brand_learning_two.88b9fd7e.png";